const IMAGE_REG = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i
const VIDEO_REG =
  /(\.mp4|\.avi|\.rmvb|\.wmv|\.flv|\.mov|\.mpg|\.mpeg|\.rm|\.asf|\.3gp|\.mkv|\.3g2|\.h264|\.m4v|\.mj2|\.ogg|\.ogv|\.qt|\.vob|\.webm|\.f4v)$/i
const DOC_REG = /(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.xls|\.xlsx)$/i

export function isCoursewareImage(fileName = '') {
  return IMAGE_REG.test(fileName)
}

export function isCoursewareVideo(fileName = '') {
  return VIDEO_REG.test(fileName)
}

export function isCoursewareDoc(fileName = '') {
  return DOC_REG.test(fileName)
}

export function getCoursewareUnavailableReason(file = {}) {
  const fileName = file.doc_name || file.file_name || ''
  if (isCoursewareDoc(fileName) && !file.pages) {
    return '不能插入页数为0的课件'
  }
  if (!file.transcode_result) {
    return '课件转码未完成，请稍后再试'
  }
  return ''
}

export function addCoursewareToWhiteboard(whiteBoardService, file = {}) {
  const error = getCoursewareUnavailableReason(file)
  if (error) {
    return {
      id: null,
      error,
    }
  }

  if (!whiteBoardService) {
    return {
      id: null,
      error: '白板未准备好，请稍后再试',
    }
  }

  const fileName = file.doc_name || file.file_name || ''
  let id = null
  try {
    if (isCoursewareVideo(fileName)) {
      id = whiteBoardService.addVideoFile({
        url: file.transcode_result,
        title: fileName,
      })
    } else if (isCoursewareImage(fileName)) {
      id = whiteBoardService.addImagesFile({
        urls: [file.transcode_result],
        title: fileName,
      })
    } else {
      id = whiteBoardService.addTranscodeFile({
        pages: file.pages,
        url: file.transcode_result,
        title: fileName,
        resolution: file.resolution,
      })
    }
  } catch (insertError) {
    console.error('addCoursewareToWhiteboard failed', insertError)
  }

  if (!id) {
    return {
      id: null,
      error: '课件插入失败，请稍后再试',
    }
  }

  return {
    id,
    error: '',
  }
}
